const CSRF_TOKEN_NAME = window.CSRF_TOKEN_NAME ?? "CRAFT_CSRF_TOKEN";

const csrfInputs = (): HTMLInputElement[] => [
  ...(<NodeListOf<HTMLInputElement>>(
    document.querySelectorAll(`input[name="${CSRF_TOKEN_NAME}"]`)
  )),
];

const fetchCsrfTokenValue = async (): Promise<string> => {
  const response = await fetch("/actions/blitz/csrf/token");
  return await response.text();
};

const populateCsrfInputs = async (): Promise<boolean> => {
  // Hydrate CSRF inputs except in Freeform forms; those are hydrated along
  // with honeypots.
  const inputs = csrfInputs().filter(
    (input) => !(input.closest("form[data-freeform]") instanceof Element)
  );

  if (inputs.length === 0) {
    return false;
  }

  const value = await fetchCsrfTokenValue();
  inputs.forEach((input) => (input.value = value));

  return true;
};

populateCsrfInputs();
